// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__6ygrh","text":"styles_text__Z9c2c","label":"styles_label__E7I8L","value":"styles_value__xp7Gx"};